import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description?: string;
  keywords?: string[];
  ogImage?: string;
  ogUrl?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description = 'Professional portfolio showcasing my projects, skills, and experience in web development and design.',
  keywords = ['portfolio', 'web developer', 'designer', 'projects'],
  ogImage = '/images/og-image.jpg',
  ogUrl,
}) => {
  const siteUrl = 'https://your-portfolio-domain.com';
  const url = ogUrl ? `${siteUrl}${ogUrl}` : siteUrl;
  
  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{`${title} | Portfolio`}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(', ')} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;